/**
 * Events › List on a phone (SAM-1308, canvas PhoneEvents): a title, a full-width search, ONE dropdown for the status
 * («All · 14») and a card per event: its dates and status, its logo and name, and a line with where and how many.
 * View only on a phone (SAM-944 M5): no «New Event», no «Public Page»; a tap opens the read-only dashboard.
 * Presentational: EventsList.tsx owns the data, the search and the filter.
 */
import React from 'react';
import { PhoneListState } from '../../components/phone/PhoneCards';
import {
  PhonePage, PhoneRowList, PhoneSearch, PhoneSelect, PhoneTitleRow, type PhoneOptionGroup, type PhoneRow,
} from '../../components/phone/PhoneListParts';
import { useT } from '../../i18n/admin';

interface Props {
  rows: PhoneRow[];
  loading: boolean;
  query: string;
  onQuery: (q: string) => void;
  /** Id of the chosen status, and its label with the count: «Published · 4». */
  filter: string;
  display: string;
  groups: PhoneOptionGroup[];
  onFilter: (id: string) => void;
  emptyText: string;
}

export const EventsListPhone: React.FC<Props> = ({ rows, loading, query, onQuery, filter, display, groups, onFilter, emptyText }) => {
  const { t } = useT();
  return (
    <PhonePage>
      <PhoneTitleRow title={t('phoneLists.events.title')} />
      <PhoneSearch placeholder={t('phoneLists.events.search')} value={query} onChange={onQuery} />
      <PhoneSelect ariaLabel={t('phoneLists.events.filterLabel')} value={filter} display={display} groups={groups} onChange={onFilter} />
      <PhoneListState loading={loading} failed={false} empty={!loading && rows.length === 0} emptyText={emptyText} />
      {!loading && rows.length > 0 && <PhoneRowList rows={rows} />}
    </PhonePage>
  );
};
